import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

const DEFAULT_LOCALE = "en-us";

export const mapLocaleToFolder = (locale_id) => {
	// Since no match was found, return default locale
	return "en-us";
};

// Checks for the file in the target directory and returns it. Else returns empty json
const provideFileDirectory = async (fileToCheck, folder, path = null) => {
	try {
		if (path) {
			return await import(`${path}/${folder}${fileToCheck}`);
		}

		return await import(`./${folder}${fileToCheck}`);
	} catch (err) {
		return {};
	}
};

export const loadMessages = async (locale_id) => {
	const base_messages = await import("./base/register.json");
	const base_signin = await import("./base/signin.json");
	const base_sidemenu = await import("./base/sidemenu.json");
	const base_dashboard = await import("./base/dashboard.json");
	const base_registration = await import("./base/registration.json");
	const base_volunteer = await import("./base/volunteer.json");
	const base_shared = await import("./base/shared.json");

	const folder = mapLocaleToFolder(locale_id);
	const messages = folder !== DEFAULT_LOCALE ? provideFileDirectory(`/register.json`, folder) : {};
	const signin = folder !== DEFAULT_LOCALE ? provideFileDirectory(`/signin.json`, folder) : {};
	const sidemenu = folder !== DEFAULT_LOCALE ? provideFileDirectory(`/sidemenu.json`, folder) : {};
	const dashboard = folder !== DEFAULT_LOCALE ? provideFileDirectory(`/dashboard.json`, folder) : {};
	const registration = folder !== DEFAULT_LOCALE ? provideFileDirectory(`/registration.json`, folder) : {};
	const volunteer = folder !== DEFAULT_LOCALE ? provideFileDirectory(`/volunteer.json`, folder) : {};
	const shared = folder !== DEFAULT_LOCALE ? provideFileDirectory(`/shared.json`, folder) : {};

	//Fake delay for now, later on we fetch partner and cohort messages from remote Urls
	await new Promise((r) => setTimeout(r, 1));

	//merge strings into one object
	return {
		...base_messages.default,
		...base_signin.default,
		...base_sidemenu.default,
		...base_dashboard.default,
		...base_registration.default,
		...base_volunteer.default,
		...base_shared.default,
		...messages,
		...signin,
		...sidemenu,
		...dashboard,
		...registration,
		...volunteer,
		...shared,
	};
};

export const String = connect((state) => ({
	doneStrings: state.context.doneStrings,
}))(({ id, values, defaultMessage = " ", doneStrings }) => {
	return <FormattedMessage id={id || "not_defined"} defaultMessage={defaultMessage} values={values} />;
});
